import { AbstractControl, UntypedFormArray, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

export class RequiredValidators {

	/**
	 * Validateur considérant que le formcontrol est obligatoire si un prédicat est vérifié.
	 * @param predicate le prédicat.
	 */
	static requiredIf(predicate) {
		return (formControl => {
			if (!formControl.parent) {
				return null;
			}
			const required: boolean = typeof predicate === 'function' ? predicate() : predicate;
			if (required) {
				return Validators.required(formControl);
			}
			return null;
		});
	}

	/**
	 * Validation que le control est not blank
	 *
	 * @param formControl le formcontrol
	 */
	static notBlank(formControl: AbstractControl) {
		if (!formControl.parent) {
			return null;
		}
		return formControl.value && ((typeof formControl.value === 'string') && formControl.value.trim() == '') ?
			{ 'notBlank': true } :
			null;
	}

	static minLengthArray(min: number) {
		return (formControl: AbstractControl): { [key: string]: any } => {
			if (formControl && formControl.value && formControl.value.length >= min) {
				return null;
			}
			return {'minLengthArray': true};
		};
	}

	static requiredPeriode(formControl: AbstractControl) {
		if (!formControl.parent) {
			return null;
		}

		if (formControl && formControl.value && Array.isArray(formControl.value) && formControl.value.length === 2 && !formControl.value.includes(null)) {
			return null;
		}
		return { requiredPeriode: true };
	}

	/**
	 * Validator qui vérifie qu'au moins un des controls du formArray est valide, selon la méthode passée en paramètre.
	 *
	 * @param elementValidator la méthode de validation des controls
	 */
	static formArrayAuMoinsUnControlValide(elementValidator: (AbstractControl) => boolean): ValidatorFn {
		return (formArray: UntypedFormArray): ValidationErrors | null => {
			if (formArray && formArray.controls && formArray.controls.some(control => elementValidator(control))) {
				return null;
			}
			return { auMoinsUnControlValide: true };
		};
	}
}
